import React from 'react';

import values                           from '../../../../values';
import Context                          from '../../../../context';
import FinancialReportCompanyComponents from './components';

import {useTranslation} from 'react-i18next';
import {
  CustomView,
  Pagination,
  ResponsiveView,
  BreadCrumb,
  TableHeader,
  TableLoading,
  CustomButton2,
  CustomTimePiker,
} from '../../../../components';

import './index.sass';

type Props = {
  resultData   : any;
}

const FactorsNeedPay2CompanyScreen: React.FC<Props> = (props: Props): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { request, setRequest } = React.useContext(Context.FactorsNeedPay2CompanyScreenContext);
  const { t } = useTranslation();

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <ResponsiveView.Container id="financial-group-screen">
      <ResponsiveView.Row className="table-options-wrapper">
        <ResponsiveView.Column extraLarge={3} large={5} medium={5} className="bread-crumb-wrapper">
          <BreadCrumb/>
        </ResponsiveView.Column>
        <ResponsiveView.Column extraLarge={5} large={7} medium={7} className="search-and-filter-wrapper">
          <CustomView.Column className='callendar-wrapper' small={7}>
            <CustomTimePiker
              defaultValue={request}
              onChange={(event: string): void => {setRequest(event)}}
              maxDate={new Date()}
              format='YYYY-MM-DD'
            />
          </CustomView.Column>
          <ResponsiveView.Column small={5}>
            <FinancialReportCompanyComponents.PayModal data={props.resultData?.data?.result} />
          </ResponsiveView.Column>
        </ResponsiveView.Column>
      </ResponsiveView.Row>
      <ResponsiveView.Container>
        <div className="table-content-wrapper">
          <table>
            <TableHeader headers={values.tableHeaders.COMPANY_DIPOSIT_DRIVER_LIST.map((item) => t(item))}/>
            {props.resultData?.status === "loading" ? (
              <TableLoading/>
            ) : (
              <FinancialReportCompanyComponents.Table driversList={props.resultData?.data?.result?.driversList}/>
            )}
          </table>
        </div>
      </ResponsiveView.Container>
      {props.resultData?.status === "success" &&
        props.resultData?.data?.result?.totalDocs > 10 && (
          <div className="pagination">
            <Pagination
              page       = { props?.resultData?.data?.result?.page                  }
              totalPages = { props.resultData?.data?.result?.totalPages             }
              onPaginate = { (page: number) => setRequest({...request, page: page}) }
            />
          </div>
        )
      }
    </ResponsiveView.Container>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
}

export default FactorsNeedPay2CompanyScreen;
